<template>
  <v-btn data-testid="dialogBtn"
         class="dialog-btn"
         :style="customStyles"
         text
         :loading="loading"
         :disabled="disabled || loading"
         @click="$emit('click')">
    <slot />
  </v-btn>
</template>
<script>

export default {
  props: {
    outline: {
      type: String,
    },
    fill: {
      type: Boolean,
    },
    color: {
      type: String,
    },
    backgroundColor: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: String,
    },
  },
  computed: {
    customStyles() {
      let styles = {}
      if (this.outline !== undefined) {
        let outlineColor = this.outline  || "rgba(0, 0, 0, 0.27)"
        styles["border"] = `1px solid ${outlineColor}`
      }
      if (this.fill) {
        styles["background-color"] = this.backgroundColor || "rgba(0, 0, 0, 0.27)"
      }
      if (this.color) {
        styles["color"] = this.color
      }
      if (this.fontSize) {
        styles["font-size"] = this.fontSize
      }
      return styles
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/abstract/_variables.scss";

.dialog-btn {
  &.v-btn {
    font-weight: 600;
    font-size: 14px;

    &:hover {
      background-color: $grey-color-7;
      border-radius: 2px;
    }

    &.disable{
      pointer-events: none;
      color: $actionDisable;
    }
  }
}
</style>
